// Shared constants for Lead components
export const STAGE_LABELS = {
  cold_data: 'Cold Data',
  attempting_contact: 'Attempting Contact',
  contacted: 'Contacted',
  qualified: 'Qualified',
  consultation_scheduled: 'Consultation Scheduled',
  consultation_completed: 'Consultation Completed',
  warm_follow_up: 'Warm Follow-Up',
  rsvp_office_event: 'RSVP Office Event',
  attended_office_event: 'Attended Office Event',
  closed_won: 'Closed Won',
  closed_lost: 'Closed Lost',
  long_term_nurture: 'Long-Term Nurture'
};

export const stageColors = {
  cold_data: 'bg-slate-100 text-slate-700 border-slate-300',
  attempting_contact: 'bg-blue-100 text-blue-800 border-blue-300',
  contacted: 'bg-indigo-100 text-indigo-800 border-indigo-300',
  qualified: 'bg-purple-100 text-purple-800 border-purple-300',
  consultation_scheduled: 'bg-cyan-100 text-cyan-800 border-cyan-300',
  consultation_completed: 'bg-teal-100 text-teal-800 border-teal-300',
  warm_follow_up: 'bg-amber-100 text-amber-800 border-amber-300',
  rsvp_office_event: 'bg-orange-100 text-orange-800 border-orange-300',
  attended_office_event: 'bg-lime-100 text-lime-800 border-lime-300',
  closed_won: 'bg-green-100 text-green-800 border-green-300',
  closed_lost: 'bg-red-100 text-red-700 border-red-300',
  long_term_nurture: 'bg-violet-100 text-violet-800 border-violet-300'
};

export const CONTACT_MODES = [
  { value: 'phone_call', label: 'Phone Call' },
  { value: 'message', label: 'Message' },
  { value: 'email', label: 'Email' },
  { value: 'video_call', label: 'Video Call' },
  { value: 'in_person', label: 'In Person' }
];
